import React, { useEffect, useRef, useState } from 'react';
import { DS } from '../ds';
import { Label } from '../Primitives';
import { GradientText } from '../Visuals';
const testimonials = [{
  name: 'Dra. Valentina Ríos',
  role: 'Ortodoncista',
  city: 'Bogotá, Colombia',
  cases: '14 casos enviados',
  quote: 'Desde el primer caso el proceso fue completamente digital y sin fricciones. La presentación del kit sorprendió a mis pacientes — varios me preguntaron si había cambiado de clínica.',
  initial: 'VR',
  color: DS.color.teal,
  photo: 'https://cdn.magicpatterns.com/patterns/generated-images/92b8aa8b-7a8e-4372-8f71-37d6987bf047.jpg'
}, {
  name: 'Dr. Sebastián Mora',
  role: 'Odontólogo general',
  city: 'Bogotá, Colombia',
  cases: '8 casos enviados',
  quote: 'No tenía infraestructura de diagnóstico digital propia. Con la solución integral de Alinova pude ofrecer ortodoncia invisible sin invertir en equipos adicionales.',
  initial: 'SM',
  color: DS.color.aqua,
  photo: 'https://cdn.magicpatterns.com/patterns/generated-images/40fcdd10-401e-4599-8729-d56ff3c0c4db.jpg'
}, {
  name: 'Dra. Camila Torres',
  role: 'Especialista en ortodoncia',
  city: 'Bogotá, Colombia',
  cases: '21 casos enviados',
  quote: 'La precisión de los alineadores es comparable con marcas internacionales. Lo que me convirtió fue la capacidad de validar cada setup antes de que avance a fabricación.',
  initial: 'CT',
  color: DS.color.kraft,
  photo: 'https://cdn.magicpatterns.com/patterns/generated-images/75a4964f-8d70-4fe9-8749-b09d5daa2712.jpg'
}, {
  name: 'Dr. Andrés Palomino',
  role: 'Odontólogo · Clínica propia',
  city: 'Bogotá, Colombia',
  cases: '6 casos enviados',
  quote: 'Empecé con el plan de fabricación porque ya tenía mi flujo digital. La respuesta fue en menos de 24 horas y el kit llegó impecable. Seguimos con más casos.',
  initial: 'AP',
  color: DS.color.tealDeep,
  photo: 'https://cdn.magicpatterns.com/patterns/generated-images/77aee9ac-7336-4b5d-ac83-8b9a924e2bfe.jpg'
}];
const StarRating = () => <div style={{
  display: 'flex',
  gap: '3px'
}} data-id="element-811" data-mp="34nea2qkfc4s9">
    {[...Array(5)].map((_, i) => <svg key={i} width="14" height="14" viewBox="0 0 14 14" fill="none" data-id="element-812" data-mp="30jgbcgz0gvzq" data-mpi={i}>
        <path d="M7 1L8.5 5H13L9.5 7.5L11 11.5L7 9L3 11.5L4.5 7.5L1 5H5.5L7 1Z" fill={DS.color.aqua} opacity="0.9" data-id="element-813" data-mp="2vmpzy6y5iokn" />
      </svg>)}
  </div>;
export const TestimonialsSection = () => {
  const [visible, setVisible] = useState(false);
  const [active, setActive] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const ref = useRef<HTMLElement>(null);
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 768px)');
    const update = () => setIsMobile(mq.matches);
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true);
        observer.disconnect();
      }
    }, {
      threshold: 0.1
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  // Auto-avance cada 5 segundos
  useEffect(() => {
    const timer = setInterval(() => {
      setActive(prev => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);
  const t = testimonials[active];
  return <section ref={ref} id="casos" style={{
    background: DS.color.ivory,
    padding: '56px 24px 96px',
    position: 'relative',
    overflow: 'hidden'
  }} data-id="element-814" data-mp="4lpktwnrrqc4">
      {/* Textura sutil */}
      <div aria-hidden="true" style={{
      position: 'absolute',
      inset: 0,
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23B5894F' fill-opacity='0.018'%3E%3Ccircle cx='40' cy='40' r='2'/%3E%3C/g%3E%3C/svg%3E\")",
      pointerEvents: 'none'
    }} data-id="element-815" data-mp="3d457c6pcf99a" />

      <div style={{
      maxWidth: '1200px',
      margin: '0 auto',
      position: 'relative',
      zIndex: 1,
      opacity: visible ? 1 : 0,
      transform: visible ? 'translateY(0)' : 'translateY(24px)',
      transition: `opacity 0.8s ${DS.ease.out}, transform 0.8s ${DS.ease.out}`
    }} data-id="element-816" data-mp="37qn8yg8l8wab">
        {/* Header */}
        <div style={{
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
        gap: '24px',
        flexWrap: 'wrap',
        marginBottom: '56px'
      }} data-id="element-817" data-mp="3qp9fiamvjflm">
          <div data-id="element-818" data-mp="1wbrw8zti54we">
            <Label data-id="element-819" data-mp="1wdch1xq0l9h2">Casos de éxito</Label>
            <h2 style={{
            fontFamily: DS.font.heading,
            fontWeight: 700,
            fontSize: 'clamp(1.8rem, 4vw, 2.8rem)',
            color: DS.color.ink,
            lineHeight: 1.12,
            letterSpacing: '-0.025em',
            marginTop: '8px'
          }} data-id="element-820" data-mp="1rcoqfd5p6und">
              Profesionales en Bogotá que ya{' '}
              <GradientText data-id="element-821" data-mp="22uwpasgukay">confían en Alinova.</GradientText>
            </h2>
          </div>

          {/* Número grande decorativo */}
          <div style={{
          fontFamily: DS.font.heading,
          fontWeight: 700,
          fontSize: '3.5rem',
          color: DS.color.tealDeep,
          opacity: 0.1,
          letterSpacing: '-0.04em',
          lineHeight: 1,
          userSelect: 'none'
        }} data-id="element-822" data-mp="3k7g0hkgwxrwl">
            {String(active + 1).padStart(2, '0')}
          </div>
        </div>

        {/* Card principal */}
        <div style={{
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr' : '1fr 1.6fr',
        gap: '2px',
        borderRadius: '28px',
        overflow: 'hidden',
        boxShadow: '0 32px 100px rgba(11,31,36,0.10)'
      }} data-id="element-823" data-mp="1dj301efq1zno">
          {/* Panel izquierdo — perfil */}
          <div style={{
          background: `linear-gradient(160deg, ${DS.color.tealDeep} 0%, #07202a 100%)`,
          padding: isMobile ? '32px 24px' : '52px 44px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          position: 'relative',
          overflow: 'hidden'
        }} data-id="element-824" data-mp="123q6rod2bz6p">
            {/* Grid CAD */}
            <div aria-hidden="true" style={{
            position: 'absolute',
            inset: 0,
            backgroundImage: 'linear-gradient(rgba(75,199,210,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(75,199,210,0.05) 1px, transparent 1px)',
            backgroundSize: '36px 36px',
            pointerEvents: 'none'
          }} data-id="element-825" data-mp="1kzpu2lv3iejy" />

            <div style={{
            position: 'relative',
            zIndex: 1
          }} data-id="element-826" data-mp="2l14dhrra19i4">
              {/* Foto del profesional */}
              <div style={{
              width: '88px',
              height: '88px',
              borderRadius: '50%',
              overflow: 'hidden',
              border: `3px solid rgba(75,199,210,0.35)`,
              marginBottom: '20px',
              boxShadow: '0 8px 28px rgba(0,0,0,0.3)',
              background: `linear-gradient(135deg, ${t.color}, ${DS.color.tealDeep})`,
              flexShrink: 0
            }} data-id="element-827" data-mp="2pzxrdlah72it">
                <img src={t.photo} alt={`Foto de ${t.name}`} style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                display: 'block'
              }} data-id="element-828" data-mp="3dp8jkedrfolc" />
              </div>

              <div style={{
              fontFamily: DS.font.heading,
              fontWeight: 700,
              fontSize: '1.15rem',
              color: '#fff',
              marginBottom: '4px',
              transition: `all 0.4s ${DS.ease.smooth}`
            }} data-id="element-829" data-mp="cwekozh5qpi2">
                {t.name}
              </div>
              <div style={{
              fontFamily: DS.font.body,
              fontSize: '13px',
              color: DS.color.aquaLight,
              fontWeight: 600,
              marginBottom: '4px'
            }} data-id="element-830" data-mp="3pc8e2uixw442">
                {t.role}
              </div>
              <div style={{
              fontFamily: DS.font.body,
              fontSize: '12px',
              color: 'rgba(255,255,255,0.4)',
              marginBottom: '20px',
              display: 'flex',
              alignItems: 'center',
              gap: '5px'
            }} data-id="element-831" data-mp="3u8p3rt5seqj9">
                {/* Pin icono */}
                <svg width="10" height="12" viewBox="0 0 10 12" fill="none" aria-hidden="true" data-id="element-832" data-mp="1lw3gg8djracl">
                  <path d="M5 0C2.8 0 1 1.8 1 4C1 7 5 12 5 12C5 12 9 7 9 4C9 1.8 7.2 0 5 0ZM5 5.5C4.2 5.5 3.5 4.8 3.5 4C3.5 3.2 4.2 2.5 5 2.5C5.8 2.5 6.5 3.2 6.5 4C6.5 4.8 5.8 5.5 5 5.5Z" fill="rgba(255,255,255,0.4)" data-id="element-833" data-mp="1d0dy687eaw3f" />
                </svg>
                {t.city}
              </div>

              {/* Badge casos */}
              <div style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '7px',
              padding: '6px 14px',
              borderRadius: '100px',
              background: 'rgba(75,199,210,0.10)',
              border: '1px solid rgba(75,199,210,0.22)'
            }} data-id="element-834" data-mp="1vropgqh19avu">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" data-id="element-835" data-mp="h6ewljczlc4c">
                  <circle cx="6" cy="6" r="5" stroke={DS.color.aqua} strokeWidth="1.2" data-id="element-836" data-mp="2j28pnzpiuas" />
                  <path d="M3.5 6l2 2 3-3" stroke={DS.color.aqua} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" data-id="element-837" data-mp="3pn08b7x06jb5" />
                </svg>
                <span style={{
                fontFamily: DS.font.body,
                fontSize: '11px',
                fontWeight: 700,
                color: DS.color.aquaLight,
                letterSpacing: '0.04em'
              }} data-id="element-838" data-mp="3ko5i3kwphsh0">
                  {t.cases}
                </span>
              </div>
            </div>

            {/* Selector de barras */}
            <div style={{
            display: 'flex',
            gap: '8px',
            position: 'relative',
            zIndex: 1,
            marginTop: '40px'
          }} data-id="element-839" data-mp="2ygja0mxq9wtr">
              {testimonials.map((_, i) => <button key={i} onClick={() => setActive(i)} aria-label={`Testimonio ${i + 1}`} style={{
              height: '4px',
              flex: i === active ? 3 : 1,
              borderRadius: '2px',
              background: i === active ? `linear-gradient(90deg, ${DS.color.aquaLight}, ${DS.color.aqua})` : 'rgba(255,255,255,0.15)',
              border: 'none',
              cursor: 'pointer',
              transition: `all 0.35s ${DS.ease.smooth}`,
              padding: 0
            }} data-id="element-840" data-mp="3m52ib2gs29lu" data-mpi={i} />)}
            </div>
          </div>

          {/* Panel derecho — cita */}
          <div style={{
          background: DS.color.white,
          padding: isMobile ? '32px 24px' : '52px 52px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          position: 'relative'
        }} data-id="element-841" data-mp="2veoqw3bykwd4">
            {/* Comillas decorativas */}
            <div aria-hidden="true" style={{
            position: 'absolute',
            top: '32px',
            right: '44px',
            fontFamily: DS.font.heading,
            fontSize: '120px',
            lineHeight: 1,
            color: DS.color.teal,
            opacity: 0.05,
            userSelect: 'none',
            fontWeight: 700
          }} data-id="element-842" data-mp="39d695lj3hgnn">
              "
            </div>

            <StarRating data-id="element-843" data-mp="1hh7u9awy5f29" />

            <blockquote style={{
            margin: '24px 0 32px',
            fontFamily: DS.font.heading,
            fontWeight: 600,
            fontSize: 'clamp(1.1rem, 2.2vw, 1.4rem)',
            color: DS.color.ink,
            lineHeight: 1.55,
            letterSpacing: '-0.01em',
            borderLeft: 'none',
            padding: 0,
            transition: `all 0.4s ${DS.ease.smooth}`
          }} data-id="element-844" data-mp="1hda9ylymuhgs">
              "{t.quote}"
            </blockquote>

            {/* Divider */}
            <div style={{
            height: '1px',
            background: DS.color.border,
            marginBottom: '28px',
            width: '80px'
          }} data-id="element-845" data-mp="1qeqisp9subiw" />

            {/* Stats row */}
            <div style={{
            display: 'flex',
            gap: '32px',
            flexWrap: 'wrap'
          }} data-id="element-846" data-mp="2e65q6wgfnj10">
              {[{
              label: 'Tiempo de respuesta',
              value: '< 24h'
            }, {
              label: 'Satisfacción',
              value: '100%'
            }, {
              label: 'Recomendaría Alinova',
              value: 'Sí'
            }].map(stat => <div key={stat.label} data-id="element-847" data-mp="1tojikxio7ov1">
                  <div style={{
                fontFamily: DS.font.heading,
                fontWeight: 700,
                fontSize: '1.4rem',
                color: DS.color.tealDeep,
                marginBottom: '2px'
              }} data-id="element-848" data-mp="1tpbbu1ospai5">
                    {stat.value}
                  </div>
                  <div style={{
                fontFamily: DS.font.body,
                fontSize: '11px',
                color: DS.color.muted,
                fontWeight: 500
              }} data-id="element-849" data-mp="2cmvomaeacime">
                    {stat.label}
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        {/* Navegación inferior — todos los perfiles */}
        <div style={{
        marginTop: '24px',
        display: 'grid',
        gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
        gap: '12px'
      }} data-id="element-850" data-mp="13esrduqveeze">
          {testimonials.map((item, i) => <button key={i} onClick={() => setActive(i)} style={{
          padding: '14px 18px',
          borderRadius: '16px',
          background: active === i ? DS.color.white : 'transparent',
          border: `1.5px solid ${active === i ? DS.color.aqua + '50' : DS.color.border}`,
          cursor: 'pointer',
          textAlign: 'left',
          transition: `all 0.25s ${DS.ease.smooth}`,
          boxShadow: active === i ? DS.shadow.card : 'none'
        }} onMouseEnter={e => {
          if (active !== i) {
            e.currentTarget.style.background = DS.color.white;
            e.currentTarget.style.borderColor = DS.color.aqua + '30';
          }
        }} onMouseLeave={e => {
          if (active !== i) {
            e.currentTarget.style.background = 'transparent';
            e.currentTarget.style.borderColor = DS.color.border;
          }
        }} data-id="element-851" data-mp="aqn2qwwp45ua" data-mpi={i}>
              <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
          }} data-id="element-852" data-mp="9zyh2y46a5p0">
                {/* Foto miniatura */}
                <div style={{
              width: '36px',
              height: '36px',
              borderRadius: '50%',
              overflow: 'hidden',
              border: `2px solid ${active === i ? DS.color.aqua + '50' : DS.color.border}`,
              flexShrink: 0,
              background: `linear-gradient(135deg, ${item.color}, ${DS.color.tealDeep})`
            }} data-id="element-853" data-mp="3ii4bnf1557du">
                  <img src={item.photo} alt={item.name} style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                display: 'block'
              }} data-id="element-854" data-mp="310p3hd24kio5" />
                </div>

                <div data-id="element-855" data-mp="2mbj5ttixr0id">
                  <div style={{
                fontFamily: DS.font.heading,
                fontWeight: 700,
                fontSize: '12px',
                color: active === i ? DS.color.tealDeep : DS.color.ink,
                marginBottom: '1px'
              }} data-id="element-856" data-mp="2m8wvxn8ko8wz">
                    {item.name.split(' ').slice(0, 2).join(' ')}
                  </div>
                  <div style={{
                fontFamily: DS.font.body,
                fontSize: '11px',
                color: DS.color.muted
              }} data-id="element-857" data-mp="50lnali66i6l">
                    {item.role}
                  </div>
                </div>
              </div>
            </button>)}
        </div>
      </div>
    </section>;
};